import { memo } from 'react';
import PropTypes from 'prop-types';

import './StatusDetails.scss';

const StatusDetails = ({ fileName = "UNKNOWN", fileType = "UNKNOWN", group = "UNKNOWN" }) => 
  (
    <div className="data-science__pipeline-creator__body__workspace__diagram__status-box__container__details">
      <div className="data-science__pipeline-creator__body__workspace__diagram__status-box__container__details__row">
        <span>File:</span> {fileName}
      </div>
      <div className="data-science__pipeline-creator__body__workspace__diagram__status-box__container__details__row">
        <span>File type:</span> {fileType}
      </div>
      <div className="data-science__pipeline-creator__body__workspace__diagram__status-box__container__details__row">
        <span>Group:</span> {group}
      </div> 
    </div>
  )

StatusDetails.propTypes = {
  fileName: PropTypes.string,
  fileType: PropTypes.string,
  group: PropTypes.string,
}

export default memo(StatusDetails);